import type { CSSProperties } from 'react';
import classes from './Section.module.css';
import type { SectionProps } from './Section.types';

const DEFAULT_VEIL_OPACITY = 0.34;

export function Section({
  children,
  id,
  backgroundVideoUrl,
  veilOpacity = DEFAULT_VEIL_OPACITY,
  videoOpacity = 1,
  className,
}: SectionProps) {
  const sectionClasses = [
    classes.section,
    backgroundVideoUrl ? classes.hasBackground : '',
    className ?? '',
  ]
    .filter(Boolean)
    .join(' ');
  const backgroundStyle = {
    '--sn-veil-opacity': veilOpacity,
    '--sn-video-opacity': videoOpacity,
  } as CSSProperties;

  return (
    <section className={sectionClasses} style={backgroundStyle} {...(id ? { id } : {})}>
      {backgroundVideoUrl ? (
        <>
          <div className={classes.background}>
            <video
              src={backgroundVideoUrl}
              autoPlay
              muted
              loop
              playsInline
              preload="auto"
              aria-hidden="true"
            />
          </div>
          <div className={classes.veil} />
        </>
      ) : null}
      <div className={classes.wrap}>{children}</div>
    </section>
  );
}
